export default "__VITE_ASSET__CQJwIuhj__"